import React,{useState, useEffect} from 'react'
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

import { PageTitle } from "../../../../../_template/layout/core/PageData";
import SAISVG from '../../../../../_template/helpers/CommonFunction';
import { toAbsoluteUrl } from '../../../../../_template/helpers/CommonFunction';

const Overview = () => {
    const loginUserType = localStorage.getItem('type');
    let botSetupHomeTitle
    if(loginUserType === 'A'){
        botSetupHomeTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
            {
                title: 'Guide',
                path: '/guide/overview',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }
    else if(loginUserType === 'D'){
        botSetupHomeTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }
    
    const overviewImgArr = [
        { src: toAbsoluteUrl('saiFile/overview/img_1.png') },
    ];
    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        const links = document.querySelectorAll(".sidebar-link");
        links.forEach((link) => {
          link.addEventListener("click", (e) => {
            e.preventDefault();
            const targetId = link.getAttribute("data-bs-target").substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
              window.scrollTo({
                top: targetElement.offsetTop - 100,
                behavior: "smooth",
              });
            }
            links.forEach((l) => l.classList.remove("guide-active"));
            link.classList.add("guide-active");
          });
        });
        return () => {
          links.forEach((link) => {
            link.removeEventListener("click", () => {});
          });
        };
    }, []);
    return (
        <>
            <PageTitle breadcrumbs={botSetupHomeTitle}>Overview</PageTitle>
            <style>
                {`
                    .yarl__container {
                        background-color: #00000099 !important;
                        backdrop-filter: blur(3px) !important;
                    }
                    .yarl__navigation_next {
                        display: none !important;
                    }
                    .yarl__navigation_prev {
                        display: none !important;
                    }
                    .side-custom-bg {
                        background: #f7fafe !important;
                    }
                    .guide-active span {
                        color: var(--sai-text-primary) !important;
                    }
                `}
            </style>
            <div className="row">
                <div className="col-md-9 col-12">
                    <div className="card card-flush border">
                        <div className="card-header mt-5">
                            <div className="card-title align-items-start flex-column">
                                <h2 className="card-label fw-bold text-gray-800 fs-3x mb-4">
                                    Overview
                                </h2>
                                <span className="text-gray-800 mt-2 fw-bold fs-1x mb-4 ">Users from all channels</span>
                            </div>
                        </div>
                        <div className="card-body pt-2">
                            <div id="overview">
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fw-bold mb-6 fs-1x">
                                        We have just made building most powerful AI Agents as simple as possible here!
                                    </h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" /> 
                                                TruVoice.ai is a Conversational AI Platform which is also like an Agentic AI. You can build high performing Virtual AI Agents for any function like Sales Agent, Support Agent, Consultative Agent, Cab Booking, E-comm Agent, Tech support and so on.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                            <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                                                TruVoice is domain and process agnostic, which means that you can build the Agents you want in any industry such as Banking, Health, Education, E-comm, IT, Wealth Management and so on. It also supports 150+ languages. 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fw-bold mb-6 fs-1x">
                                        You can build your Agents in two ways
                                    </h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                1.	Build your own agent and manage it, using simple UI interfaces via this platform.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                2.	Have us build and maintain your Agents. For this please write to
                                                <span className='text-primary ms-1'>sales@truvoice.ai</span>.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-8">
                                    <p className="text-gray-800 fs-5 ms-6 mb-6 mt-2">
                                        Please note that the platform supports English Agents only at the moment. For other languages, you can contact us at sales@truvoice.ai
                                    </p>
                                    <p className="text-primary fs-5 ms-6 mb-6 mt-2">
                                        Here is the guidance on how to choose between the platform or us to build your Virtual Agents.
                                    </p>
                                    <p className="text-gray-800 fs-5 ms-6 mb-6 mt-2">
                                        The rest of the information in this portal is about using the platform to build your own Agents.
                                    </p>
                                </div>
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fw-bold mb-6 fs-1x">
                                        Building your own AI Agents that perform specific tasks
                                    </h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                You can build AI Agents that perform specific tasks as you define it. TruVoice model is to replicate to the how a human agent would engage with customers, to the best extent possible via AI. The kind of tasks that are typically required to be performed are:
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-8">
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                1. Providing simple information such as FAQs: For example, “what is the product return policy?”
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                2. Seeking clarifications before providing specific information: For example, “what is the room tariff in your hotel?” The Agent has to inquire about date, number of guests and such details before providing the tariff.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                3.	Fulfilling a service: For example, “I want to buy a product”. The Agent has to give the product options, number of items, collect information such as delivery address, name of the buyer, collect payment details such as credit card, expiry date and so on, then place an order and provide the order details back to the buyer.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                4.	Consultative advice: For example, “- Find me good mutual funds to invest”. The Agent has to understand the risk appetite by asking interactive questions, understand time period, objective, explain different types of mutual funds, and then suggest based of the preferences.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                5.	Fulfilment: The Agent should be able to interact with other applications such as Payment Gateways, CRMs, or other Agents like transferring from a Sales AI Agent to Support AI Agent or to a human agent based on business logic.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                6.	General chat: For example, to respond to Greetings, Wishes and so on.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                7.	Change in Conversations: For example, while making a purchase the Consumer may ask in between,” what is a guarantee or warranty?”. The Agent should be able to answer it and get to the purchase conversation from where it was left.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                8.	Change in topics: For example, the consumer may change mind by saying, “No, I will have a burger instead of pizza”. The Agent should be able to say if it can cancel the pizza request.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                9.	Disambiguation: For example, consumers may ask out of scope queries or certain queries which are not understood by the Agent. The Agent should be able to ask for clarification and steer the conversation back to right track just like a human agent does.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                10.	Validations: When Agent collects information from the consumer such as Age, Card Number, Amount and so on, all such information should be validated.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-8">
                                    <p className="text-gray-800 fs-5 fw-bold ms-6 mb-6 mt-2">
                                        You can build AI Agents that perform all these kinds of interactions and more with TruVoice.ai.
                                    </p>
                                </div>
                            </div>
                            <div id="channels">
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fs-1 fw-bold my-5 mb-6">Channels</h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                You can integrate these AI Agents into any channel you like. The default channel is Chat. You can use the highly advanced Chat System inbuilt by TruVoice.ai. For other channels such as WhatsApp, Facebook or so, you can integrate them with AI Agents via APIs. 
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                However, each channel may have its own limitation. For example, WhatsApp does not provide buttons. Facebook allows only three options at one time. You are advised to review the specific channels and build your Agents specifically to such channels.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="voice_ai_agents">
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fs-1 fw-bold my-5 mb-6">
                                        Voice AI Agents
                                    </h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                Building a Voice Agent additional layer of speech models trained for specific languages, choice of voice or persona, adding SIP or WebRTC and so on. With TruVoice.ai you have the entire flexibility. Once you build you AI Assistant, you can integrate with any of the components as needed for Voice Channel. 
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                However, the conversational patterns in Voice Assistants are somewhat different from that of Chat format. You can refer to Guide and Best Practices for more guidance on this.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                Please note that the Platform version supports only Chat format at the moment. We will post right here when Voice is also available here. In the meantime, for Voice Agents, you can write to <span className='text-primary'>sales@truvoice.ai</span> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="pre_requisite_technical_knowledge">
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fs-1 fw-bold my-5 mb-6">
                                        Technical Knowledge
                                    </h4>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                Building an Agent via platform does not require any technical knowledge. It’s a no-code platform. All you need to do is to know what the Agent should perform, just like to specify to a human agent.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6 lh-lg">
                                            <div className="text-gray-800 fw-semibold fs-6">
                                                However, integrations with APIs, 3rd party systems, channels, voice channel may require some technical knowledge based on those systems. TruVoice.ai provides detailed documentation on standard approaches for these. If required, you can seek our support by writing to <span className='text-primary'>sales@truvoice.ai</span> . 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="process_overview">
                                <div className="mb-8">
                                    <h4 className="text-gray-800 fs-1 fw-bold my-5 mb-6">
                                        Process Overview
                                    </h4>
                                    <div className="row mt-3">
                                        <div className="col-md-1"></div>
                                        <div className="col-md-10 border border-dashed rounded border-gray-400 me-2 p-3 mb-4">
                                            <img
                                                className="w-100 cursor-pointer" 
                                                alt="Logo"
                                                src={overviewImgArr[0].src}
                                                onClick={() => { setOpen(true); setCurrentIndex(0) }}
                                            />
                                        </div>
                                    </div>
                                    <div className="my-2 ms-6">
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                                <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                                                Make sure that you have credit balances required before deploying the Agents.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                                <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                                                Machine training and NLU will be performed on first-come-first-serve basis. The completion will also depend on the volume of training and existing requests on the system. The expected turn-around time is 3-5 working days at present.
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center mb-6">
                                            <div className="text-gray-800 fw-semibold fs-6 lh-lg">
                                                <SAISVG path="media/icons/duotune/abstract/abs050.svg" className="svg-icon-9 me-3 text-gray-800" />
                                                For any support during the process, please write to <span className='text-primary'>support@truvoice.ai</span>.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-8" id="pci_compliance">
                                <h4 className="text-gray-800 fs-1 fw-bold my-5">
                                    PCI Compliance
                                </h4>
                                <div className="my-2 ms-6">
                                    <div className="d-flex align-items-center mb-6">
                                        <div className="text-gray-800 fw-semibold fs-6">
                                            Coming soon.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-8" id="data_security">
                                <h4 className="text-gray-800 fs-1 fw-bold my-5">
                                    Data Security
                                </h4>
                                <div className="my-2 ms-6">
                                    <div className="d-flex align-items-center mb-6">
                                        <div className="text-gray-800 fw-semibold fs-6">
                                            Coming soon.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card position-fixed fill-wd">
                        <div className="card-body card-rounded px-0 px-6 py-6 side-custom-bg" bis_skin_checked="1" >
                            <ul id="kt_sidebar_nav" className="nav nav-flush menu menu-column menu-title-gray-600 menu-bullet-gray-600 menu-state-primary fw-bold fs-6 mb-8">
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#overview"
                                    >
                                    <span className="menu-title fw-semibold">Overview</span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#channels"
                                    >
                                    <span className="menu-title fw-semibold">Channels</span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                    type="button"
                                    className="menu-link p-0 nav-link sidebar-link"
                                    data-kt-scroll-toggle="true"
                                    data-bs-target="#voice_ai_agents"
                                    >
                                    <span className="menu-title fw-semibold">Voice AI Agents</span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#pre_requisite_technical_knowledge"
                                    >
                                        <span className="menu-title fw-semibold">
                                            Technical Knowledge
                                        </span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#process_overview"
                                    >
                                        <span className="menu-title fw-semibold">Process Overview</span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#pci_compliance"
                                    >
                                        <span className="menu-title fw-semibold">PCI Compliance</span>
                                    </button>
                                </li>
                                <li className="menu-item py-2">
                                    <button
                                        type="button"
                                        className="menu-link p-0 nav-link sidebar-link"
                                        data-kt-scroll-toggle="true"
                                        data-bs-target="#data_security"
                                    >
                                        <span className="menu-title fw-semibold">Data Security</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={[overviewImgArr[currentIndex]]}
                currentIndex={currentIndex}
                carousel={{ finite: true }}
            />
        </>
    )
}

export default Overview